import { AlertService } from './alert.service';
import { AuthGuard } from './auth-guard.service';
import { CompanyLogoService } from './company-logo.service';
import { DestroyHelper } from './destroy-helper.service';
import { GtOAuthService } from './gt-oauth.service';
import { GtSessionStorageService } from './gt-session-storage.service';
import { LoginService } from './login.service';
import { SessionStorageService } from './session-storage.service';
import { GtLocalStorageService } from './gt-local-storage.service';
import { LoginChallengeDataService } from './login-challenge-data.service';
import { DomainDataService } from './domain-data.service';
import { LoginPageApiService } from './login-page-api.service';

export const APP_SERVICES = [
  LoginService,
  DestroyHelper,
  SessionStorageService,
  CompanyLogoService,
  AlertService,
  GtOAuthService,
  GtSessionStorageService,
  AuthGuard,
  GtLocalStorageService,
  LoginChallengeDataService,
  DomainDataService,
  LoginPageApiService
];
